import React, { useState } from "react";
import "../Styles/FaqAccordion.css";
import { FaPlus, FaMinus } from "react-icons/fa";
import faqData from "../contents/faq";

const FaqAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-title">Frequently Ask Question</h2>
      <p className="faq-subtext">
        We use only the best quality materials on the market in order to provide
        the best products to our patients.
      </p>
      <div className="faq-items">
        {faqData.map((faq, index) => (
          <div
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            key={index}
          >
            <div
              className="faq-question"
              onClick={() => toggleAccordion(index)}
            >
              <span className="bullet">•</span> {faq.question}
              <span className="faq-icon">
                {activeIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqAccordion;
